import { clsx } from "clsx";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import type { OrbMessage, AgentMessageStyle } from "./types";
import { useMessageLayout } from "./useMessageLayout";

export function VoiceMessageList({
  messages: rawMessages,
  alignMessages = "bottom",
  agentMessageStyle = "default",
}: {
  messages: OrbMessage[];
  alignMessages?: "top" | "bottom";
  agentMessageStyle?: AgentMessageStyle;
}) {
  const { messages, layoutKey, messagesInitial } = useMessageLayout(rawMessages);

  return (
    <div
      className='tw-absolute -tw-inset-x-3 sm:-tw-inset-x-12 -tw-top-12 -tw-bottom-12 tw-py-20 tw-flex tw-flex-col-reverse'
      style={{
        maskImage:
          "linear-gradient(to bottom, transparent, white 3rem, white calc(100% - 5rem), transparent calc(100% - 2rem))",
      }}
    >
      <m.div
        key={layoutKey}
        layout={messages.length > 0 ? "position" : undefined}
        className={clsx("tw-flex tw-flex-col tw-gap-4", alignMessages === "top" ? "tw-mb-auto" : "tw-mt-auto")}
      >
        <AnimatePresence mode='popLayout' initial={messagesInitial}>
          {messages.map((message, index, arr) => (
            <VoiceMessage
              key={message.id}
              {...message}
              agentMessageStyle={agentMessageStyle}
              className={clsx(index === 0 && "tw-mt-auto", index === arr.length - 1 && "tw-mb-auto")}
            />
          ))}
        </AnimatePresence>
      </m.div>
    </div>
  );
}

function VoiceMessage({
  message,
  role,
  className,
  agentMessageStyle = "default",
}: OrbMessage & { className?: string; agentMessageStyle?: AgentMessageStyle }) {
  return (
    <m.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={clsx(
        "tw-rounded-2.5xl tw-w-fit tw-py-2 sm:tw-py-2.5 tw-px-3 sm:tw-px-4 tw-max-w-[calc(100%-2rem)] sm:tw-max-w-[calc(100%-4rem)] tw-text-xs/[1.125rem] sm:tw-text-sm/5 tw-text-black",
        role === "agent" && "tw-ml-auto",
        role === "agent" && agentMessageStyle === "dark" && "tw-bg-gray-200",
        role === "agent" && agentMessageStyle !== "dark" && agentMessageStyle !== "warm" && "tw-bg-white",
        role === "user" && "tw-bg-white",
        message === "" && "!tw-opacity-0",
        className,
      )}
      style={role === "agent" && agentMessageStyle === "warm" ? { backgroundColor: "#F5F3F1" } : undefined}
    >
      {message}
    </m.p>
  );
}
